import createIcon from '../../createIcon';

/**
 * @component @name MoveDown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy41IDEwLjVDMy41IDEyLjk1IDUuMjYgMTQuOTcgNy41OCAxNS40MUw2LjA5IDEzLjkyTDcuNSAxMi41TDExLjUgMTYuNTFMNy41IDIwLjVMNi4wOSAxOS4wOUw3LjY3IDE3LjUxVjE3LjQ1QzQuMiAxNy4wNCAxLjUgMTQuMDggMS41IDEwLjVDMS41IDYuNjMgNC42MyAzLjUgOC41IDMuNUgxMS41VjUuNUg4LjVDNS43NCA1LjUgMy41IDcuNzQgMy41IDEwLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjIuNSAxMC41VjMuNUgxMy41VjEwLjVIMjIuNVpNMjAuNSA4LjVIMTUuNVY1LjVIMjAuNVY4LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjIuNSAxMi41SDEzLjVWMTkuNUgyMi41VjEyLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MoveDown = createIcon('MoveDown', [
  [
    'path',
    {
      d: 'M3.5 10.5C3.5 12.95 5.26 14.97 7.58 15.41L6.09 13.92L7.5 12.5L11.5 16.51L7.5 20.5L6.09 19.09L7.67 17.51V17.45C4.2 17.04 1.5 14.08 1.5 10.5C1.5 6.63 4.63 3.5 8.5 3.5H11.5V5.5H8.5C5.74 5.5 3.5 7.74 3.5 10.5Z',
      key: '15i1pj',
    },
  ],
  ['path', { d: 'M22.5 10.5V3.5H13.5V10.5H22.5ZM20.5 8.5H15.5V5.5H20.5V8.5Z', key: 'lkais' }],
  ['path', { d: 'M22.5 12.5H13.5V19.5H22.5V12.5Z', key: 'nl2b15' }],
]);

export default MoveDown;
